/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ScreenLayoutService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getByRoute(reportRoute) {
    const requestScreenData = {
      url: "api/ScreenLayout",
      top: "1",
      filter: `Route eq '${reportRoute}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getAllRouteOnly() {
    const requestScreenData = {
      url: "api/ScreenLayout",
      select: "ApplicationFeatureCode,Route",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { ScreenLayoutService };
